'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Tooltip = require('./Tooltip');

var _Tooltip2 = _interopRequireDefault(_Tooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var ConditionalTooltip = function ConditionalTooltip(_ref) {
  var condition = _ref.condition,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ['condition', 'children']);

  return condition ? _react2.default.createElement(
    _Tooltip2.default,
    rest,
    children
  ) : children;
};

ConditionalTooltip.propTypes = process.env.NODE_ENV !== "production" ? {
  condition: _propTypes2.default.bool,
  children: _propTypes2.default.any
} : {};

exports.default = ConditionalTooltip;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/li-components/lib/next/Tooltip/ConditionalTooltip.js
// module id = 2300
// module chunks = 14